import config from "@Config/index";
import axios from "axios";
import urlBuilder from "@Utils/urlBuilder";

/* eslint-disable func-names */
export const isInternalUser = function (authObject: any) {
  if (
    authObject &&
    (authObject?.status || authObject?.data?.status) &&
    authObject.data &&
    authObject.data.email &&
    authObject.data.email.includes("amberstudent.com")
  ) {
    return true;
  }
  return false;
};

export const isLoggedIn = function (authObject: any) {
  if (authObject && authObject.status) {
    return true;
  }
  return false;
};

export const hasPartnerDashboardAccess = async (
  user_auth_token: string,
  partnerDashboardUrl: string,
) => {
  try {
    const paths = [config.API_URL, partnerDashboardUrl];
    const res = await axios(
      urlBuilder(paths, {
        params: {
          cache: "false",
        },
      }),
      {
        params: {
          user_auth_token,
        },
      },
    );

    return Boolean(res?.status === 200 && res?.data?.data?.result.length > 0);
  } catch (error) {
    return false;
  }
};
